export const navigationSize = '15.5rem';
export const layoutMargin = '1.5rem';
